//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/PcbExchange.js";
import "../no/Object.js";
import "../no/Session.js";
let d=[[],[[["fName","nLayers","layerNames","nNets"],"Read",{R_:{netNames:""}},1,0],[["fName","layerNames","netNames","bTextualFilter","textualFilterStr"],"Update",{},5,0]],[]];
SPLM.PcbExchange.ExtdataUpdator = class extends SPLM.Object{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PcbExchange.ExtdataUpdator";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;